export default __webpack_public_path__ + "static/media/20thBG.d136ed28.jpg";